/*
 * HelpScreen3
 * ==========
 */
import HelpBase from '../ui/HelpBase'

export default class HelpScreen3 extends HelpBase {

  constructor (game, screens) {
    super(game);

    this.screens = screens;

    this.page = 3;

    this.params = {
      'helpLinesArrow1P': [127, 130],
      'helpLinesArrow2P': [53, -113],
      'helpLinesColumnP': [211, 1],
      'helpLinesRowP': [-1, -211],
      'helpLinesUiP': [-1, -321],
      'helpLinesTextP': [-17, 29],
      'helpLinesArrow1L': [202, 123],
      'helpLinesArrow2L': [107, -107],
      'helpLinesColumnL': [289, -1],
      'helpLinesRowL': [77, -213],
      'helpLinesUiL': [-242, 38],
      'helpLinesTextL': [61, 28],
      'prevL': [-50, 194],
      'nextL': [158, 194],
      'exitL': [54, 194],
      'prevP': [-104, 203],
      'nextP': [107, 203],
      'exitP': [2, 203]
    };

    this.helpLinesArrow1P = this.addSprite('helpLinesArrow1P', 'helpScreens', 'helpLinesArrow1.png', 'p');
    this.helpLinesArrow2P = this.addSprite('helpLinesArrow2P', 'helpScreens', 'helpLinesArrow2.png', 'p');
    this.helpLinesColumnP = this.addSprite('helpLinesColumnP', 'helpScreens', 'helpLinesColumn.png', 'p');
    this.helpLinesRowP = this.addSprite('helpLinesRowP', 'helpScreens', 'helpLinesRow.png', 'p');
    this.helpLinesUiP = this.addSprite('helpLinesUiP', 'helpScreens', 'helpLinesUi.png', 'p');
    this.helpLinesTextP = this.addSprite('helpLinesTextP', 'helpScreens', 'helpLinesText.png', 'p');

    this.helpLinesArrow1L = this.addSprite('helpLinesArrow1L', 'helpScreens', 'helpLinesArrow1.png', 'l');
    this.helpLinesArrow2L = this.addSprite('helpLinesArrow2L', 'helpScreens', 'helpLinesArrow2.png', 'l');
    this.helpLinesColumnL = this.addSprite('helpLinesColumnL', 'helpScreens', 'helpLinesColumn.png', 'l');
    this.helpLinesRowL = this.addSprite('helpLinesRowL', 'helpScreens', 'helpLinesRow.png', 'l');
    this.helpLinesUiL = this.addSprite('helpLinesUiL', 'helpScreens', 'helpLinesUiLandscape.png', 'l');
    this.helpLinesTextL = this.addSprite('helpLinesTextL', 'helpScreens', 'helpLinesText.png', 'l');

    this.helpLinesColumnP.scale.set(0.975);
    this.helpLinesColumnL.scale.set(0.975);
    this.helpLinesRowP.scale.set(0.975);
    this.helpLinesRowL.scale.set(0.975);

    this.initHelpButtons();

    this.setInputForAllButtons(false)
  }

}
